/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-28 14:55:08
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Card, Tabs } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import FilterTab from 'src/components/views/filter-settings/display/filter-tab';
import ProductListTab from 'src/components/views/filter-settings/display/product-list-tab';

type Props = {
  clearCache: Function,
  loadingClearCache: boolean,
  themeSetupV2: boolean,
  optionsList: Object,
  appLanguage: string
};

type ComposedProps = Props & WithI18nProps;

type State = { selected: number };

class DisplaySettings extends Component<ComposedProps, State> {
  state = {
    selected: 0
  };
  componentWillReceiveProps(nextProps) {
    const { selectedTab: selectedTabPrev } = this.props;
    const { selectedTab } = nextProps;
    if (!selectedTabPrev && selectedTab) {
      this.setState({ selected: selectedTab });
    }
  }

  handleTabChange = selectedTabIndex => {
    this.setState({ selected: selectedTabIndex });
  };

  render() {
    const { selected } = this.state;
    const { clearCache, loadingClearCache, themeSetupV2, optionsList, appLanguage, i18n } =
      this.props;
    const tabs = [
      {
        id: 'filter',
        content: i18n.translate('AdminHTML.FilterSettings.Display.display_Tab1_Content'),
        accessibilityLabel: i18n.translate(
          'AdminHTML.FilterSettings.Display.display_Tab1_AccessibilityLabel'
        ),
        panelID: 'filter'
      },
      {
        id: 'product-list',
        content: i18n.translate('AdminHTML.FilterSettings.Display.display_Tab2_Content'),
        panelID: 'product-list'
      }
    ];

    const tabComponents = [
      <FilterTab
        themeSetupV2={themeSetupV2}
        clearCache={clearCache}
        loadingClearCache={loadingClearCache}
      />,
      <ProductListTab
        themeSetupV2={themeSetupV2}
        optionsList={optionsList}
        appLanguage={appLanguage}
      />
    ];
    return (
      <div className="tabs">
        <Card>
          <Tabs tabs={tabs} selected={selected} onSelect={this.handleTabChange}>
            <Card.Section>{tabComponents[selected]}</Card.Section>
          </Tabs>
        </Card>
      </div>
    );
  }
}

export default withI18n()(DisplaySettings);
